var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1432,
    height: 108,
    viewBox: "0 0 1432 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1432 0L1372 2.55C1312 5.1 1192 10.2 1072 28.2C952 46.125 832 76.875 712 69.225C592 61.575 472 15.375 352 15.375C232 15.375 112 61.5 52 84.6L-8 107.625V0H1432Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopFooter);
export default __webpack_public_path__ + "static/media/top-footer.718a8a0fee06e9ba734d92afa04f44be.svg";
export { ForwardRef as ReactComponent };